import {RomeApi} from "./rome-api";
import fileDownload from "js-file-download";

class CobraApi extends RomeApi {
    constructor() {
      super();
    }

    async GetElectionEvents(participantId) {
        return await this.get(
            `/participant/${participantId}/election-event`,
        );
    }

    async GetElectionEvent(participantId, electionEventId) {
      return await this.get(
          `/participant/${participantId}/election-event/${electionEventId}`,
      );
    }

    async SaveElectionEvent(participantId, electionEventId, type, lifeEventType, eventDate, elections, disabled, disabilityNoticeRequiredByDate, sendElectionNotice) {
      let data = {
        participantId,
        type,
        lifeEventType,
        eventDate,
        elections,
        disabled,
        disabilityNoticeRequiredByDate,
        sendElectionNotice
      };

      if (!electionEventId)
        await this.post(`/participant/${participantId}/election-event`, data);
      else
        await this.put(`/participant/${participantId}/election-event/${electionEventId}/amend`, data);
    }

    async GetPayments(participantId) {
        return await this.get(
            `/participant/${participantId}/payment`,
        );
    }

    async CreatePayment(participantId, payment) {
        const response = await this.post(
          `/participant/${participantId}/payment`,
          {...payment, participantId: participantId}
        );
        return response;
    }

    async getPricing(pricingDate, participantId, planId, coverageLevelId, dependentIds) {
      return await this.post(`participant/${participantId}/election/pricing`, {
        pricingDate: pricingDate,
        planId: planId,
        coverageLevelId: coverageLevelId,
        dependentIds: dependentIds
      });
    }

  async download(relativeUrl, data){
    this.processJsonData(data);
    let cfg = {
      params: data,
      responseType: 'blob'
    };

    var response =  await this.api.get(relativeUrl, cfg);
    fileDownload(response.data, this.getFileName(response));
  }

  getFileName(response, filename){
    let contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      let startIndex = contentDisposition.indexOf('filename=');
      let endIndex = contentDisposition.indexOf(';', startIndex);

      if (endIndex < 0) endIndex = contentDisposition.length;
      if (startIndex > 0 && contentDisposition.length > startIndex + 9) {
        filename = contentDisposition.substring(startIndex + 9, endIndex);
      }
    }
    if (!filename)
      throw 'Either the API must provide a filename or download must be called with a filename argument.';
    return filename;
  };
}

const cobraApi = new CobraApi();
export { cobraApi }



// WEBPACK FOOTER //
// ./src/framework/utils/cobra-api.js